
import { defineComponent, ref } from "vue";
import CreateBillingModal from "@/components/modals/general/CreateBillingModal.vue";

export default defineComponent({
  name: "payment-methods",
  props: {
    cardClasses: String,
    paymentProfiles: Array,
  },
  components: { CreateBillingModal },
  setup() {
    const cardLogos = ref({
      Visa: "visa",
      Mastercard: "mastercard",
      "American Express": "american-express",
    });

    const getBillingAddress = (profile) => {
      return `${profile.street1} ${profile.city}, ${profile.state} ${profile.zip} ${profile.country}`;
    };

    return {
      cardLogos,
      getBillingAddress,
    };
  },
});
